import { Descriptions, Divider, Drawer } from "antd"; 
import React, { useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import { numberWithCommas } from "../../../../../../utils";

function ProductionproddViewView({ onClose, open, proddView }) { 
  const items1 = [
    {
      key: "0",
      label: "Amount",
      children: proddView?.prodAmount ?? "N/A",
    },
    {
      key: "1",
      label: "Category",
      children: proddView?.prodCat ?? "N/A",
    },
    {
      key: "5",
      label: "Cropped Area",
      children: proddView?.prodCroppedArea ?? "N/A",
    },
    {
      key: "2",
      label: "Crops",
      children: proddView?.prodCrops ?? "N/A",
    },
    {
      key: "3",
      label: "Produce Sold (kgs)",
      children:<div>{numberWithCommas(proddView?.prodProduceSold ?? "N/A")}</div>,
    },

    {
      key: "4",
      label: "Total Produce",
      children:<div>{numberWithCommas(proddView?.prodTotalProduce ?? "N/A")}</div>,
    },
    
    {
      key: "5",
      label: "Total Revenue",
      children:<div>{numberWithCommas(proddView?.prodTotalRevenue ?? "N/A")}</div>,
    }, 
    {
      key: "6",
      label: "Comments",
      children: proddView?.prodComments ?? "N/A",
    },
  ];
 
  

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Production Data Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Prouction Details"
          column={3}
          colon={false}
          items={items1}
          layout="vertical"
        />
       
      </div>
    </Drawer>
  );
}

export default ProductionproddViewView;
